// extracted by css-extract-rspack-plugin
var _1 = "BGzqdmpnDw8u_m5O";
var _2 = "RmwfAn9TYiULXSA3";
var _3 = "CCDY4zl7GD0JTgE8";
var _4 = "FK56R1lXEoqzdf3O";
var _5 = "c9sJmnjV_869PEF6";
var _6 = "hsbqv8wYTUowfdLX";
var _7 = "S_x4gjUB0IceC7sr";
var _8 = "lul3Tq6jkPC0BaxR";
var _9 = "ULdppog2QMBzJktV";
var _a = "UDRvVOqxC5Eg8zyE";
export { _1 as "bidMessageIconRow", _2 as "closed", _3 as "declined", _4 as "icon", _5 as "leading", _6 as "outbid", _7 as "pending", _8 as "register", _9 as "register-body", _a as "seller-name" }
